export default __webpack_public_path__ + "static/media/f-12.18c1bf48.jpg";